import React, { useState } from 'react'

import { NavLink as RouterNavLink, NavLinkProps, useParams } from 'react-router-dom'
import { Add as AddIcon } from '@material-ui/icons'

import { useQueryPaginator } from 'src/components/Table'
import { BatchDetailTable } from 'src/components/Table/detail/Batch'
import { BatchDialog } from 'src/modules/supply_chain/components/BatchDialog'
import { BatchSkuListTable } from 'src/components/Table/list/BatchSku'
import { PalletListTable } from 'src/components/Table/list/Pallet'
import { UnitListTable } from 'src/components/Table/list/Unit'

import { skuit } from 'src/services/skuit'
import { useQuery } from 'react-query'

import { DetailPage } from 'src/components/Pages/DetailPage'

const NavLink = React.forwardRef((props: NavLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
  <RouterNavLink innerRef={ref} {...props} />
))
NavLink.displayName = 'NavLink'

interface PathProps {
  guid: string
}

export const BatchPage = () => {
  const { guid } = useParams<PathProps>()
  const [createOpen, setCreateOpen] = useState(false)

  const batch = useQuery(['batch-details', guid], () => skuit.sc.batches.retrieve(guid))
  const palletPaginator = useQueryPaginator('pallet-list', skuit.sc.pallets.list, {
    params: { page_size: 5, batches: guid },
  })
  const batchSkuPaginator = useQueryPaginator(
    'batch-sku-list',
    skuit.sc.batchSkus.list,
    {params: { page_size: 5, batches: guid }},
  )
  const unitsPaginator = useQueryPaginator(
    'unit-list',
    skuit.sc.units.list,
    {params: { page_size: 5, batches: guid }},
  )

  const refresh = () => {
    batch.refetch()
  }

  return (
    <>
      {createOpen && (
        <BatchDialog
          open={createOpen}
          handleClose={() => {
            setCreateOpen(false)
          }}
        />
      )}
      <DetailPage
        obj={batch}
        title="Batches"
        refresh={refresh}
        breadcrumbs={[
          { title: 'Dashboard', url: '/' },
          { title: 'Batches', url: '/inventory/batches' },
        ]}
        detailComponent={<BatchDetailTable obj={batch} refresh={refresh} />}
        menuItems={[
          {
            Icon: AddIcon,
            actions: [{ title: 'New Batch', onClick: () => setCreateOpen(true) }],
          },
        ]}
      >
        <BatchSkuListTable
          paginator={batchSkuPaginator}
          title="SKUs"
          fields={['sku', 'product', 'numAvailable', 'numReserved', 'numAwaitingShipment']}
        />
        <UnitListTable
          paginator={unitsPaginator}
          title="Storage Locations"
          fields={['path', 'numUnits']}
        />
        <PalletListTable
          paginator={palletPaginator}
          title="Pallets"
          fields={['name', 'client', 'clientID', 'skus', 'path', 'totalUnits', 'asn']}
        />
      </DetailPage>
    </>
  )
}
